import MakeOrder from '@/pages/MakeOrder'

export default {
    path: '',
    component: MakeOrder,
    children: [
        {
            path: '/make/order/:ref',
            name: 'Make Order',
            component: MakeOrder,
        }
    ]
}



// WEBPACK FOOTER //
// ./src/router/makeorder.js